import React from "react";

interface LoadingProps {
  fullScreen?: boolean;
  text?: string;
}

const Loading: React.FC<LoadingProps> = ({
  fullScreen = true,
  text = "Chargement en cours..."
}) => {
  const content = (
    <div className="flex flex-col items-center justify-center gap-6 text-center">
      {/* Double cercle animé */}
      <div className="relative w-20 h-20">
        {/* Cercle extérieur (rotation lente) */}
        <div className="absolute inset-0 border-2 border-primary/20 rounded-full animate-[spin_3s_linear_infinite]" />
        {/* Cercle intérieur (rotation inverse rapide) */}
        <div className="absolute inset-2 border-t-2 border-secondary rounded-full animate-[spin_1.5s_linear_infinite]" />
        {/* Point central */}
        <div className="absolute inset-0 flex items-center justify-center">
          <div className="w-2 h-2 bg-primary rounded-full animate-pulse" />
        </div>
        {/* Logo au centre (optionnel) */}
        <img
          src="/assets/logo/favicon.png"
          alt="Braincrea"
          className="absolute w-16 h-16 top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full bg-dark/50 p-1"
        />
      </div>

      {/* Texte avec effet de vague */}
      <div className="relative">
        <p className="text-sm font-medium text-white/80 tracking-wide">
          {text}
        </p>
        <div className="absolute -bottom-1 left-0 w-full h-px bg-gradient-to-r from-transparent via-primary to-transparent animate-pulse" />
      </div>

      {/* Points de progression animés */}
      <div className="flex gap-1.5">
        {[0, 1, 2].map((i) => (
          <div
            key={i}
            className="w-1.5 h-1.5 rounded-full bg-primary/60"
            style={{
              animation: `bounce 1s ease-in-out ${i * 0.2}s infinite`,
            }}
          />
        ))}
      </div>
    </div>
  );

  if (fullScreen) {
    return (
      <div className="fixed inset-0 z-50 flex items-center justify-center bg-dark/95 backdrop-blur-md transition-all duration-300">
        {content}
      </div>
    );
  }

  return <div className="py-8">{content}</div>;
};

// Ajout des animations personnalisées dans un style global (ou via Tailwind config)
// Pour que bounce fonctionne, ajoutez ceci dans votre fichier CSS global :
/*
@keyframes bounce {
  0%, 100% { transform: translateY(0); opacity: 0.3; }
  50% { transform: translateY(-6px); opacity: 1; }
}
*/

export default Loading;